"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMerchantAjaxRequest = sendMerchantAjaxRequest;
var _demoRequest = require("./demo-request");
var _request = require("./request");
var _requestOptions = require("./request-options");
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreMerge = _interopRequireDefault(require("../core-merge"));
var _coreSanitize = _interopRequireDefault(require("../core-sanitize"));
var _coreLog = require("../core-log");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/
/**
 * Sends AJAX request to a merchant API.
 *
 * @param {string} url The URL of the AJAX request handler
 * @param {object} options JS object containing the request payload and
 * result callbacks
 */
function sendMerchantAjaxRequest(url, options) {
  var defaults = {
    'headers': {
      //      'Content-Type': 'application/json; charset=UTF-8',
      //      'Pragma': 'no-cache'
    }
  };
  var mergedOptions = _coreMerge["default"].merge({}, defaults, options);
  var opts = (0, _requestOptions.createBackendRequestOptions)('sendMerchantAjaxRequest', mergedOptions);
  if (!opts) {
    return;
  }

  // check for partner supplied token header configuration
  var headers = _coreConfig["default"].get(_coreConfig["default"].external).partnerHeaders;
  if (headers && Array.isArray(headers)) {
    var _iterator = _createForOfIteratorHelper(headers),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var header = _step.value;
        var name = _coreSanitize["default"].sanitizeHeader(header.name);
        var value = _coreSanitize["default"].sanitizeHeader(header.value);
        if (name && value) {
          // add partner token header
          opts.headers[name] = value;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  // add response time log to Merchant requests
  (0, _coreLog.addResponseTimeLog)(url, opts);
  if ((0, _demoRequest.isDemoMode)(opts.serviceKey)) {
    (0, _demoRequest.demoRequest)(opts);
  } else {
    (0, _request.ajaxRequest)(url, opts);
  }
}
//# sourceMappingURL=merchant-request.js.map